import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navigation = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => {
    if (path === '/tours') {
      return location.pathname === '/tours' || location.pathname.startsWith('/tours/');
    }
    return location.pathname === path;
  };

  return (
    <nav className="bg-white shadow-md fixed w-full top-0 z-50 transition-all duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center space-x-3">
            <img
              src="https://uxmagic.blob.core.windows.net/components/uploads/Untitled%20design%20(2)-1765043517183-a2blnuh7e8j.png"
              alt="VishwaVoyagerz"
              className="h-12 w-auto"
            />
            <div className="flex flex-col">
              <span className="text-xl font-bold bg-gradient-to-r from-brand-green via-brand-teal to-brand-blue bg-clip-text text-transparent">
                VishwaVoyagerz
              </span>
              <span className="text-xs text-brand-cyan">Tours and Travels</span>
            </div>
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className={`font-medium transition transform hover:scale-110 ${isActive('/') ? 'text-brand-teal' : 'text-gray-700 hover:text-brand-teal'
                }`}
            >
              Home
            </Link>
            <Link
              to="/tours"
              className={`font-medium transition transform hover:scale-110 ${isActive('/tours') ? 'text-brand-teal' : 'text-gray-700 hover:text-brand-teal'
                }`}
            >
              Tours
            </Link>
            <Link
              to="/categories"
              className={`font-medium transition transform hover:scale-110 ${isActive('/categories') ? 'text-brand-teal' : 'text-gray-700 hover:text-brand-teal'
                }`}
            >
              Categories
            </Link>
            <Link
              to="/villas"
              className={`font-medium transition transform hover:scale-110 ${isActive('/villas') ? 'text-brand-teal' : 'text-gray-700 hover:text-brand-teal'
                }`}
            >
              Villas
            </Link>
            <Link
              to="/about"
              className={`font-medium transition transform hover:scale-110 ${isActive('/about') ? 'text-brand-teal' : 'text-gray-700 hover:text-brand-teal'
                }`}
            >
              About
            </Link>
            <Link
              to="/contact"
              className={`font-medium transition transform hover:scale-110 ${isActive('/contact') ? 'text-brand-teal' : 'text-gray-700 hover:text-brand-teal'
                }`}
            >
              Contact
            </Link>

            <Link
              to="/tours"
              className="bg-gradient-to-r from-brand-teal to-brand-cyan text-white px-6 py-2 rounded-full hover:shadow-lg transition transform hover:scale-110"
            >
              Book Now
            </Link>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden text-gray-700 text-2xl"
          >
            <i className="fas fa-bars"></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-white border-t">
            <div className="px-4 py-6 space-y-4">
              <Link
                to="/"
                className="block text-gray-700 hover:text-brand-teal font-medium py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                Home
              </Link>
              <Link
                to="/tours"
                className="block text-gray-700 hover:text-brand-teal font-medium py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                Tours
              </Link>
              <Link
                to="/categories"
                className="block text-gray-700 hover:text-brand-teal font-medium py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                Categories
              </Link>
              <Link
                to="/villas"
                className="block text-gray-700 hover:text-brand-teal font-medium py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                Villas
              </Link>
              <Link
                to="/about"
                className="block text-gray-700 hover:text-brand-teal font-medium py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                About
              </Link>
              <Link
                to="/contact"
                className="block text-gray-700 hover:text-brand-teal font-medium py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                Contact
              </Link>

              <Link
                to="/tours"
                className="w-full bg-gradient-to-r from-brand-teal to-brand-cyan text-white px-6 py-3 rounded-full hover:shadow-lg transition block text-center"
                onClick={() => setMobileMenuOpen(false)}
              >
                Book Now
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;

